
import { Component, Vue } from "vue-property-decorator";

@Component
export default class SuccessAlert extends Vue {
  message = this.$store.getters.getSuccess;
  timeout: ReturnType<typeof setTimeout> = setTimeout(() => {}, 1);

  get display() {
    return this.message !== "";
  }

  set display(newVal) {
    this.hideSuccessAlert();
  }

  created() {
    this.$store.watch(
      (state, getters) => getters.getSuccess,
      () => {
        clearTimeout(this.timeout);
        this.message = this.$store.getters.getSuccess;
        this.timeout = setTimeout(this.hideSuccessAlert, 3000);
      }
    );
  }

  hideSuccessAlert() {
    clearTimeout(this.timeout);
    this.$store.dispatch("clearSuccess");
  }
}
